import React, { useEffect, useState } from 'react';
type Item = {
  label: string;
  to: string;
};

/**
 * Sticky in-page subnav, sitting directly under the site header.
 * Used on the long content and text pages (About, FAQs, Shipping & Returns)
 * in place of a side rail. Highlights the section currently in view.
 */
export function SectionNav({
  items,
  label = 'On this page'
}: {
  items: Item[];
  label?: string;
}) {
  const [active, setActive] = useState<string | null>(null);
  useEffect(() => {
    const ids = items.map(i => i.to.replace(/^.*#/, ''));
    const targets = ids.map(id => document.getElementById(id)).filter((el): el is HTMLElement => el !== null);
    if (!targets.length) return;
    const observer = new IntersectionObserver(entries => {
      const visible = entries.filter(e => e.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
      if (visible[0]) setActive(visible[0].target.id);
    }, {
      rootMargin: '-140px 0px -60% 0px',
      threshold: 0
    });
    targets.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, [items]);
  return <nav aria-label={label} className="sticky top-[73px] z-30 border-b border-oat/50 bg-paper/95 backdrop-blur-md" data-id="element-235" data-mp="177rokadrr80j">
      <div className="no-scrollbar mx-auto flex max-w-[1400px] gap-2 overflow-x-auto px-6 py-4 lg:flex-wrap lg:overflow-visible" data-id="element-236" data-mp="xfc7rge7kph8">
        {items.map(item => {
        const id = item.to.replace(/^.*#/, '');
        const isActive = active === id;
        return <a key={item.to} href={item.to} aria-current={isActive ? 'true' : undefined} className={`type-cta shrink-0 rounded-full border px-5 py-2.5 text-[10px] transition-colors duration-150 ${isActive ? 'border-coffee bg-coffee text-paper' : 'border-oat text-coffee/70 hover:border-coffee hover:text-coffee'}`} data-id="element-237" data-mp="afo6nigyaiaa">
              {item.label}
            </a>;
      })}
      </div>
    </nav>;
}